import React, { useState, useEffect } from 'react';

function Demo() {
  const data = [
    {
      Name: "Mallikarjun",
      Place: "Gulbarga",
    },
    {
      Name: "Ram",
      Place: "Goa",
    },
  ];

  const [number, Setnumber] = useState(0);
  const [str, setStr] = useState("Mallikarjun");
  const [reversedStr, setReversedStr] = useState("");
  const [data2, setData2] = useState([]);
  const [inputValue, setInputValue] = useState(""); // To store the input value

  function Reversestring(str) {
    return str.split("").reverse().join("");
  }

  useEffect(() => {
    setReversedStr(Reversestring(str));
  }, [str]);

  
  function handlepush() {
    if (inputValue.trim()) { 
      setData2([...data2, inputValue]);
      setInputValue("");
    }
  }

  // Function to delete an item from the data2 array
  function handleDelete(indexToRemove) {
    const updatedData = data2.filter((_, index) => index !== indexToRemove); // Filter out the clicked item
    setData2(updatedData);
  }

  return (
    <>
      <div>Demo</div>
      {data.map((item, index) => (
        <h1 className="text-3xl font-bold mb-10" key={index}>
          Name: {item.Name}
          <br />
          Place: {item.Place}
        </h1>
      ))}

      <input
        type="text"
        placeholder="Enter names"
        className="text-3xl mb-10"
        value={inputValue} // Bind the input to inputValue
        onChange={(e) => setInputValue(e.target.value)} // Update inputValue on change
      />
      <button className="text-3xl mb-10" onClick={handlepush}>
        ADD
      </button>

      {data2.map((item, index) => (
        <h1 className="text-3xl font-bold mb-10" key={index}>
          {item} <input type="checkbox" /> 
          <button className="ml-2 text-red-500" onClick={() => handleDelete(index)}>
            Delete
          </button>
        </h1>
      ))}

      <h1 onClick={() => Setnumber(number + 1)}>Count={number}</h1>

      <h1>
        <input
          onChange={(e) => setStr(e.target.value)}
          id="put"
          type="text"
          placeholder="Enter name..."
        />
      
      </h1>

      <h1>Reversed String: {reversedStr}</h1>
      {console.log(reversedStr)}
    </>
  );
}

export default Demo;
